<template>
  <transition-group
    v-bind="transitionProps"
    tag="div"
  >
    <AvatarColor
      v-if="showGenericIcon"
      key="avatarColor"
    />
    <img
      v-else-if="applicationLogoUrl"
      key="avatarLogo"
      :class="logoClass"
      :src="applicationLogoUrl"
    >
  </transition-group>
</template>

<script>
import { ItemTypeConsts, StoreModelMap } from 'client/util/Constants';
import { mapGetters, mapState } from 'vuex';
import AvatarColor from 'client/components/Applications/AvatarColor.vue';

const { application } = ItemTypeConsts;
const applicationModel = StoreModelMap[application];

export default {
  name: 'ApplicationAvatar',

  components: { AvatarColor },

  computed: {
    ...mapGetters(applicationModel, [
      'logoUrl',
      'templateLogoUrl',
    ]),

    ...mapState(applicationModel, [
      'appLogo',
      'isDefaultLogoRestored',
      'item',
    ]),

    applicationLogoUrl() {
      if (this.appLogo && this.appLogo.imageUrl) {
        return this.appLogo.imageUrl;
      }
      if (this.isDefaultLogoRestored) {
        return this.templateLogoUrl;
      }
      return this.logoUrl;
    },

    logoClass() {
      return {
        [`${this.$style.avatarLogoStyle}`]: true,
        [`${this.$style.customOidc}`]: this.item.name === 'oidc',
      };
    },

    showGenericIcon() {
      return this.item.color && this.item.displayLabel;
    },

    transitionProps() {
      return {
        enterClass: this.$style.avatarFadeTo,
        enterActiveClass: this.$style.avatarEnterTransition,
        leaveActiveClass: this.$style.avatarFadeTo,
        leaveToClass: this.$style.avatarFadeTo,
      };
    },
  },
};
</script>
<style module>
.avatarFadeTo {
  opacity: 0;
}

.avatarEnterTransition {
  transition: opacity 0.15s ease-in-out;
}

.avatarLogoStyle {
  height: 4rem;
  object-fit: contain;
  width: 100%;
}

.customOidc {
  padding: 0 var(--jc-spacer);
}
</style>
